module.exports = __webpack_public_path__ + "28b67065/img/question-icon.06c20c5d.svg";